import React, { useState } from 'react'
import { ArrowRightIcon } from '../icons';
import { Link } from 'react-router-dom';

// Entries without a link (exited companies) render as plain text.
const ItemLink = ({ link, children }) => link
    ? <Link target='_blank' rel='noreferrer' to={link}>{children}</Link>
    : <span>{children}</span>

const ListCard = ({ v, listHovering, setCurrentImage, setActiveLink, index, activeLink }) => {

    const [hovered, setHovered] = useState(false);

    const isSmScreen = window.innerWidth < 900;

    const mouseOver = () => {
        setHovered(true);
        setCurrentImage(v.img)
    }
    const mouseOut = () => setHovered(false);

    const handleLinkClick = () => {
        setActiveLink(index);
    };

    return (
        <>
            {isSmScreen ? <div>
                <button onClick={handleLinkClick} className={`list__item__btn ${index === activeLink ? "active__btn" : ""}`}>
                    <div className='name__section'>
                        {v.name}
                    </div>
                    <div className='link__section'>
                        <ItemLink link={v.link}>{v.showSloganOnMob ? v.slogan : v.description}{" "}{v.link ? <ArrowRightIcon /> : ""}</ItemLink>
                    </div>
                </button>
            </div> : <div className={`${listHovering ? "list_hover" : ""} ${hovered ? "active_list_item" : ""} list__item`}>
                <div className='slogan'>{v.slogan}</div>
                <div onMouseOver={mouseOver} onMouseOut={mouseOut}>
                    <ItemLink link={v.link}>{v.name}</ItemLink>
                </div>
                <div className='description__section'>{v.description}</div>
            </div>}
        </>
    )
}

export default ListCard
